// extracted by mini-css-extract-plugin
export default {"mainWrapper":"eoq9J","menuItem":"FKtyR"};